<template lang="pug">
  div
    sidebar
      transition-group.group-list(
        name="list-complete",
        mode="out-in",
        tag="ul")
        li.list-complete-item(key="제어권한 요청")
          router-link.group-link(:to="{name: 'ticket-request'}")
            icon(name="folder-o")
            span {{$t('ticket-request')}}
    div.lmm-content-body
      div.lmm-content-body-padded
        sub-header
        router-view
</template>

<script>
import Sidebar from '../mixins/sidebar'

export default {
  name: 'ticket-component',
  components: { 'sidebar': Sidebar }
}
</script>

<style lang="scss" scoped>
.group-list {
  margin: 0; padding: 0;
  list-style: none;
  font-size: 14px;

  li {
    height: 40px;
    line-height: 38px;

    &.list-label {
      display: block;
      width: 100%;
      padding: 0 8px 0 16px;
      text-align: left;
      font-weight: 200;
      color: #fff;
    }

    .group-link {
      display: block;
      width: 100%;
      padding: 0 8px 0 16px;
      text-align: left;
      font-weight: 200;
      color: #869fb1;
      background-color: #16232d;

      &.router-link-exact-active {
        color: #ffffff;
        background-color: #24b39b;
        > span { font-weight: 300; }
      }
      &:hover {
        // background-color: #16232d;
        color: #fff;
      }
      > svg { vertical-align: middle; }
      > span {
        display: inline-block;
        padding: 1px 10px;
        vertical-align: top;
      }
    }

    &.active .group-link {
      background-color: #38d2b8;
      color: #fff;
    }
  }
}

.list-complete-item {
  transition: transform 500ms;
}
.list-complete-enter {
  transform: translateX(-220px);
}
.list-complete-leave-to {
  // transform: translateX(220px);
  display: none;
}
.list-complete-leave-active {
  // position: absolute;
}
</style>
